import React from 'react'

// import AlgoliaPartnersArticles from 'components/shared/AlgoliaPartnersArticles'
import TitleHero from 'components/slices/TitleHero'
import SliceManager from 'components/shared/SliceManager'
import CirclePictureContent from 'components/shared/CardWithArrowLink/CirclePictureContent'

import { getDataDependencies } from 'services/api'
import { CardWithArrowLinkProps } from 'components/shared/CardWithArrowLink'
import { algoliaPartnersAdapter } from 'adapters/partners'
import algolia from 'src/services/algolia'
import AlgoliaArticles from 'components/shared/AlgoliaArticles'
import { fetchFacets } from 'src/services/algoliaHelpers'
import fetchSingleType from 'src/lib/Strapi/fetchSingleType'
import css from './styles.module.scss'

const index = 'partners'
const Partners = ({
  pageData: { intro, decoration, slices },
  articles,
  facets,
}) => {
  const customCardProps = CardWithArrowLinkProps.customCardProps
  
  return (
    <div className="container">
      {intro && <TitleHero {...intro} decoration={decoration} />}
      <AlgoliaArticles
        index={index}
        initialAlgolia={articles}
        adapter={algoliaPartnersAdapter}
        placeholder="Search a partner"
        labelType="Solution Partners"
        pathname="/partners"
        facets={facets}
        fullSearch={false}
        customCardComponent={(props) => (
          <CirclePictureContent
            {...props}
            className={[
              css.partnerCard,
              props.level
                ? css[`partnerCard-${props?.level.toLowerCase()}`]
                : null,
            ]}
          />
        )}
        customCardProps={customCardProps}
        isAdvancedFilter
      />
      {slices && <SliceManager slices={slices} />}
    </div>
  )
}

const partnersFacets = {
  services: {
    label: 'Services',
    multi: true,
  },
  countries: {
    label: 'Countries',
    multi: true,
  },
  type: {
    label: 'Type',
    multi: true,
  },
}

export async function getServerSideProps({ query, res }) {
  const articles = await algolia(index).search('', {
    hitsPerPage: 12,
    page: 0,
    filters: 'type:"Solution Partner" AND publishedAt:true',
  })
  const facets = await fetchFacets([index, partnersFacets])
  const pageData = await fetchSingleType('partners-grid')
  const extendedData = await getDataDependencies(pageData)

  return {
    props: {
      pageData: extendedData,
      articles,
      facets,
    },
  }
}

export default Partners
